/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VCenterServerModule
 */

import { Collection } from 'ajs/modules/data-model/factories/collection.factory';
import { VCenterServer } from './vcenter-server.item.factory';

export class VCenterServerCollection extends Collection {
    public items: VCenterServer[];

    constructor(args = {}) {
        const extendedArgs = {
            ...args,
            objectName: 'vcenterserver',
            permissionName: 'PERMISSION_CLOUD',
            windowElement: 'lazy-load',
        };

        super(extendedArgs);

        this.itemClass_ = this.getAjsDependency_('VCenterServer');
    }
}

VCenterServerCollection.ajsDependencies = [
    'VCenterServer',
];
